(function () {
    'use strict';

    angular
        .module('adminODDControllers')
        .controller('AdminODDController', Controller);

    Controller.$inject = ['$scope', '$interval', 'topBarService', 'adminODDService'];

    function Controller($scope, $interval, topBarService, adminODDService) {

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Manage ODD', 'fa icon icon-clipboard');

        var intervalPromise;

        $scope.ctrlCtxt = {
            echoTest: null
        };

        $scope.launchEchoTest = function () {
            $scope.ctrlCtxt.echoTest = null;

            return adminODDService
                    .launchEchoTest()
                    .then(function (echoTestResult) {
                        $scope.ctrlCtxt.echoTest = echoTestResult;
                        refreshResult();
                    });
        };

        function refreshResult() {
            intervalPromise = $interval(function () {
                adminODDService
                    .getLastEchoTestResult()
                    .then(function (echoTestResult) {
                        $scope.ctrlCtxt.echoTest = echoTestResult;
                        if (!echoTestResult || echoTestResult.EchoStatus !== 'In Progress') {
                            $interval.cancel(intervalPromise);
                        }
                    });
            }, 2000);
        }

        $scope.$on('$destroy', function() {
            if (intervalPromise) {
                $interval.cancel(intervalPromise);
            }
        });

        refreshResult();
    }
})();